import { render, staticRenderFns } from "./preference-widgets-layout.vue?vue&type=template&id=1f6970a8"
import script from "./preference-widgets-layout.vue?vue&type=script&lang=js"
export * from "./preference-widgets-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports